import React from "react";

import {addNotification} from "../state/notifications_slice";

export const addFailureNotification = (message: string | React.JSX.Element, timeout?: number) =>
    addNotification({
        notification: {content: message, type: "failure"},
        timeout
    });
import React from "react";

import {addNotification} from "../state/notifications_slice";

export const addFailureNotification = (message: string | React.JSX.Element, timeout?: number) =>
    addNotification({
        notification: {content: message, type: "failure"},
        timeout
    });
